import * as React from "react";

const MapIcon: React.FC<React.SVGProps<SVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="31"
    fill="none"
    viewBox="0 0 31 31"
  >
    <path
      fill="#000"
      d="M27.423 6.4a.49.49 0 0 0-.415-.089l-7.576 1.894-7.59-3.795a.5.5 0 0 0-.335-.036L3.758 6.31a.484.484 0 0 0-.366.47V24.22a.484.484 0 0 0 .605.47l7.576-1.894 7.59 3.795a.48.48 0 0 0 .334.036l7.75-1.937a.484.484 0 0 0 .363-.47V6.78a.49.49 0 0 0-.186-.381m-15.314-.773 6.782 3.39v16.356l-6.782-3.39zM4.36 7.16l6.782-1.695v16.44l-6.782 1.695zm22.282 16.682-6.782 1.695V9.096l6.782-1.695z"
    ></path>
  </svg>
);

export default MapIcon;
